import React from 'react';
import { BORDER_RADIUS_SMALL, SCREEN_PADDING_XS } from '@/styles';
import {
  DETAIL_CONTENT_MIN_WIDTH,
  ORIGINAL_INBOUND_CONTENT_MIN_WIDTH,
} from './inbound-detail-split-container';
import { PAGE_CONTAINER_PADDING_HORIZONTAL, WEB_MARGIN_TOP } from './utils';
import { Platform, StyleSheet } from 'react-native';
import {
  SplitPageContainer,
  Props as SplitPageContainerProps,
} from '@/components/split-page-container';
import { useLayoutContext } from '@/contexts/layout-context';

type Props = Omit<SplitPageContainerProps, 'title'>;

const SPLIT_PAGE_PRIMARY_CONTENT_MIN_WIDTH = 280;

export const InboundListSplitPageContainer: React.FC<Props> = ({
  navigationHeaderProps,
  ...restProps
}) => {
  const { isLargeLayout } = useLayoutContext();
  const {
    containerStyle: navigationHeaderContainerStyle,
    ...restNavigationHeaderProps
  } = navigationHeaderProps ?? {};

  return (
    <SplitPageContainer
      baseStyle={styles.splitContainerBase}
      enableResize={isLargeLayout}
      navigationHeaderProps={{
        containerStyle: [
          styles.splitNavigationContainer,
          Platform.OS === 'web' ? styles.listHeaderWeb : null,
          navigationHeaderContainerStyle,
        ],
        contentStyle: styles.splitNavigationContent,
        showShadow: false,
        ...restNavigationHeaderProps,
      }}
      primaryMinWidth={SPLIT_PAGE_PRIMARY_CONTENT_MIN_WIDTH}
      primaryPanelStyle={styles.primaryPanel}
      secondaryMinWidth={
        ORIGINAL_INBOUND_CONTENT_MIN_WIDTH +
        DETAIL_CONTENT_MIN_WIDTH +
        SPLIT_PAGE_PRIMARY_CONTENT_MIN_WIDTH
      }
      secondaryPanelStyle={styles.secondaryPanel}
      skipPanelSpacing={isLargeLayout}
      title={null}
      {...restProps}
    />
  );
};

const styles = StyleSheet.create({
  listHeaderWeb: {
    paddingTop: WEB_MARGIN_TOP,
  },
  primaryPanel: {
    borderBottomRightRadius: BORDER_RADIUS_SMALL,
    borderTopRightRadius: BORDER_RADIUS_SMALL,
    marginRight: SCREEN_PADDING_XS,
  },
  secondaryPanel: {
    borderTopLeftRadius: BORDER_RADIUS_SMALL,
  },
  splitContainerBase: {
    paddingTop: SCREEN_PADDING_XS,
  },
  splitNavigationContainer: {
    paddingHorizontal: PAGE_CONTAINER_PADDING_HORIZONTAL,
  },
  splitNavigationContent: {
    marginBottom: 0,
  },
});
